/**
 * Returns the most recent value per key across all items for a given field.
 * @param {Array} items
 * @param {string} field - "planning" | "realized"
 * @returns {Object}
 */
export const getMostRecentPerKey = (items, field) => {
  const result = {};

  (items || []).forEach((item) => {
    const obj = item?.[field] || {};
    Object.entries(obj).forEach(([key, value]) => {
      if (!value) return;
      if (!result[key] || new Date(value) > new Date(result[key])) {
        result[key] = value;
      }
    });
  });

  return result;
};

/**
 * Maps the raw attachments of a versao into the normalised attachment shape.
 * @param {Object} versao
 * @returns {Array}
 */
export const mapVersionAttachments = (versao) =>
  (versao.attachments || []).map((a) => ({
    ...a,
    id: a.id ?? a.fileId,
    parentId: versao.id,
    type: "material",
    versionNumber: versao.version,
  }));

/** Shared MUI sx for the selection checkboxes (supports indeterminate state). */
export const CHECKBOX_SX = {
  color: "#43444D",
  "&.Mui-checked": { color: "#43444D" },
  "&.MuiCheckbox-indeterminate": { color: "#43444D" },
  "&.Mui-disabled": { color: "#CCCCCC" },
};
